export const MOCK_USER_NAME = 'Juan';
export const MOCK_AVATAR_URL = '/user.png';
export const BASE_ADVANCE_AMOUNT = 78;
export const STANDARD_DELIVERY_LABEL = '2-3 days';
export const INSTANT_DELIVERY_LABEL = '5 minutes';
